import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[trimOnValueChange]',
  standalone: false,
})
export class TrimOnValueChangeDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this.el.nativeElement.value,
      trimmedValue = initialValue?.toString()?.trim(),
      hasLeadingSpaces = initialValue?.toString()?.startsWith(' ');
    if (hasLeadingSpaces) {
      this.el.nativeElement.value = trimmedValue;
    }
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
  @HostListener('blur', ['$event']) onBlur(event) {
    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue?.toString()?.trim();
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
